//hook
import { useState, useEffect } from "react";
import { useApi } from "../../hooks/useApi";


// component
import Carousel from "../../Component/Carousel/Carousel"
import AmenitiesCard from "../../Component/AmenitiesCard";
import RoomCard from "../../Component/RoomCard/RoomCard";
import TestimonialCard from "../../Component/TestimonialCard";
import ContactSection from "../../Component/ContactSection";

//api
import { GetSettings } from "../../api/setting/GetSettings";
import { GetHomeAmenities } from "../../api/amenities/GetHomeAmenities";
import { GetHomeRoom } from "../../api/room/GetHomeRoom";
import { GetTestimonials } from "../../api/testimonials/GetTestimonials";
import { GetGallery } from "../../api/gallery/GetGallery";

//mui
import { Button } from "@mui/material";
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import ReplayIcon from '@mui/icons-material/Replay';

//swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

//css file
import styles from "./Home.module.css"

//translate
import { useTranslation } from 'react-i18next';
import i18n from "../../translate/i18n";
import GalleryCard from "../../Component/GalleryCard";
import Booking from "../../popup/Booking";

//type
import { settingsTypeRes } from "../../api/setting/type/SettingsType";
import { amenityType } from "../../api/amenities/type/AmenitiesType";
import { roomType } from "../../api/room/type/RoomType";
import { galleryType } from "../../api/gallery/type/GalleryType";
import { testimonialType } from "../../api/testimonials/type/testimonialsType";

const storageURL = process.env.REACT_APP_STORAGE_BASE_URL;
const params  = [
  "about.en_section_home_page",
  "about.ar_section_home_page",
  "about.image1"
]
const galleryParams = "number=12"


interface HomeProps {
  bookingRequest: {cardId: number | null; open: boolean, type: string};
  setBookingRequest: (bookingRequest: {cardId: number | null; open: boolean, type: string}) => void
}
const Home = ({bookingRequest, setBookingRequest}:HomeProps) => {
  const {t} = useTranslation();
  let [aboutDataSection, setAboutDataSection] = useState<settingsTypeRes[]>();
  let [amenitySection, setAmenitySection] = useState<amenityType[]>();
  let [roomSection, setRoomSection] = useState<roomType[]>();
  let [homeGallerySection, setHomeGallerySection] = useState<galleryType[]>();
  let [testimonialsSection, setTestimonialsSection] = useState<testimonialType[]>();
  
  const {
    loading: homeAboutLoading,
    error: homeAboutError,
    HandlerApi: homeAboutApi
  } = useApi(GetSettings, "GET");
  const {
    loading: homeAmenitiesLoading,
    error: homeAmenitiesError,
    HandlerApi: homeAmenitiestApi
  } = useApi(GetHomeAmenities, "GET");
  const {
    loading: homeRoomsLoading,
    error: homeRoomsError,
    HandlerApi: homeRoomsApi
  } = useApi(GetHomeRoom, "GET");
  const {
    loading: galleryLoading,
    error: galleryError,
    HandlerApi: galleryApi
  } = useApi(GetGallery, "GET");
  const {
    loading: homeTestimonialLoading,
    error: homeTestimonialError,
    HandlerApi: homeTestimonialApi
  } = useApi(GetTestimonials, "GET");

  useEffect(() => {
    const fetchData = async () => {
      const homeAboutSection = await homeAboutApi(params);
      setAboutDataSection(homeAboutSection.data);
      const homeAmenitiesSection = await homeAmenitiestApi();
      setAmenitySection(homeAmenitiesSection.data);
      const homeRoomsSection = await homeRoomsApi();
      setRoomSection(homeRoomsSection.data);
      const gallerySection = await galleryApi(galleryParams);
      setHomeGallerySection(gallerySection.data);
      const homeTestimonialsSection = await homeTestimonialApi();
      setTestimonialsSection(homeTestimonialsSection.data);
      };
    fetchData();
    }, []);

  const otherLangKeyPrefix = i18n.language === 'ar' ? 'about.ar_' : 'about.en_';
  const filteredAboutContent = aboutDataSection?.filter(item => {
      const key = item.key;
      const isCurrentLangContent = key.startsWith(otherLangKeyPrefix);
      const isGenericOrCurrent = !key.startsWith(otherLangKeyPrefix);
      return isCurrentLangContent || (isGenericOrCurrent && !key.includes('_section_home_page'));
  });

  return (
    <div className="h-full !text-primaryColor">
      <Carousel />
      <div className="bg-[#EDEBDF]">
        <Box
        sx={{
        display: "flex", 
        justifyContent: "space-between", 
        alignItems: "center", 
        flexDirection: {md: "row",xs: "column"},
        padding: {md: "40px", xs: "20px"},
        direction: i18n.language === "ar" ? "rtl" : "ltr",
        }} 
        className="max-w-[1560px] m-auto gap-[10px] text-primaryColor"
        >
      {homeAboutLoading 
      ? 
      <div className='flex justify-center w-full'>
        <CircularProgress/>
      </div>
      :
      homeAboutError
      ?
      <div className='cursor-pointer flex justify-center w-full'>
        <ReplayIcon onClick={()=>homeAboutApi(params)} className='!text-[40px]' />
      </div>
      :
      <> 
        {filteredAboutContent?.map((element, index) => {
          if(element.key === "about.en_section_home_page" || element.key === "about.ar_section_home_page") {
            return (
              <Box key={index} sx={{ width: { md: "50%", xs: "100%" } }} className="w-1/2">
                <div className={`homeAboutSection leading-10 ${styles.homeAboutSection} mb-5 ${i18n.language === "en" ? "en font-palab" : "ar font-helvetica-arabic-bold"}`} 
                dangerouslySetInnerHTML={{ __html: element.value || "" }} 
                />
                <Button className={`${i18n.language === "en" ? "!font-helvetica-light" : "!font-helvetica-arabic-light"} !bg-secondaryColor !text-primaryColor !rounded-lg max-sm:!text-[12px]`}>
                  {t("learn_more_history")}
                </Button>
              </Box>
            )
          }
          else {
            return(
              <Box key={index}
                sx={{ width: { md: "50%" }, marginTop: { md: "0px", xs: "10px" } }}
                className="w-[600px] h-[500px]"
              >
                <Box
                  sx={{ borderRadius: { md: "15px", xs: "25px" } }}
                  className="!w-full !h-full object-cover"
                  component="img"
                  src={`${storageURL}/${element.value}`}
                  alt="no_photo"
                />
              </Box>
            )
          }
        })}
      </>
      }
        </Box>
      </div>
      <div dir={i18n.language === "en" ? "ltr" : "rtl"} className="bg-primaryColor py-10 ">
        <Box sx={{padding: {md: "40px", xs: "20px"}}} className={`max-w-[1560px] m-auto gap-[10px] ${i18n.language === "en" ? "font-palab" : "font-helvetica-arabic-bold"} text-center`}>
          <h2 className="sm:text-5xl max-sm:text-2xl mb-4 text-secondaryColor">
            {t("luxury_amenities")}
          </h2>
          <p className="max-w-[600px] mb-4 m-auto text-white">{t("amenities_description")}</p>
          {homeAmenitiesLoading 
          ? 
          <div className='flex justify-center w-full'>
            <CircularProgress className="!text-white"/>
          </div>
          :
          homeAmenitiesError
          ?
          <div className='cursor-pointer flex justify-center w-full'>
            <ReplayIcon onClick={homeAmenitiestApi} className='!text-[40px] !text-white' />
          </div>
          :
          <>
            <div className="grid md:grid-cols-3 sm:grid-cols-2 gap-5">
              {amenitySection?.map((element, index)=>{
                return <AmenitiesCard key={index} element={element}/>
              })}
            </div>
          </>
          }
        </Box>
      </div>
      <div dir={i18n.language === "en" ? "ltr" : "rtl"} className="py-10 bg-[#EDEBDF]">
        <Box sx={{padding: {md: "40px", xs: "20px"}}} className={`max-w-[1560px] m-auto gap-[10px] ${i18n.language === "en" ? "font-palab" : "font-helvetica-arabic-bold"} text-center`}>
          <h2 className="sm:text-5xl max-sm:text-2xl mb-4 text-primaryColor">
            {t("room_suites")}
          </h2>
          <p className="max-w-[600px] mb-4 m-auto">{t("rooms_description")}</p>
          {homeRoomsLoading 
          ? 
          <div className='flex justify-center w-full'>
            <CircularProgress/>
          </div>
          :
          homeRoomsError
          ?
          <div className='cursor-pointer flex justify-center w-full'>
            <ReplayIcon onClick={homeRoomsApi} className='!text-[40px]' />
          </div>
          :
          <>
            <div className="grid md:grid-cols-3 grid-cols-1 gap-5">
              {roomSection?.map((element, index)=>{
                return <RoomCard key={index} element={element} setBookingRequest={setBookingRequest}/>
              })}
            </div>
          </>
          }
        </Box>
        <Booking bookingRequest={bookingRequest} setBookingRequest={setBookingRequest}/>
      </div>
      <div dir={i18n.language === "en" ? "ltr" : "rtl"} className="bg-primaryColor py-10 ">
        <Box sx={{padding: {md: "40px", xs: "20px"}}} className={`max-w-[1560px] m-auto gap-[10px] ${i18n.language === "en" ? "font-palab" : "font-helvetica-arabic-bold"} text-center`}>
          <h2 className="sm:text-5xl max-sm:text-2xl mb-4 text-secondaryColor">
              {t("photo_gallery")}
          </h2>
          <p className="max-w-[600px] mb-4 m-auto text-white">{t("gallery_description")}</p>
          {galleryLoading 
            ? 
            <div className='flex justify-center w-full'>
              <CircularProgress className="!text-white"/>
            </div>
            :
            galleryError
            ?
            <div className='cursor-pointer flex justify-center w-full'>
              <ReplayIcon onClick={()=>galleryApi(galleryParams)} className='!text-[40px] !text-white' />
            </div>
            :
            <>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {homeGallerySection?.map((element, index) =>{
                  return (
                    element.images.map((item, index)=>{
                      return (
                        <GalleryCard key={index} item={item}/>
                      );
                    })
                  );
                }
                )}
              </div>
            </>
          }
        </Box>
      </div>
      <div className={`py-10 bg-[#EDEBDF] ${i18n.language === "ar" ? `rtlSwiper ${styles.rtlSwiper}` : `ltrSwiper ${styles.ltrSwiper}`}`} >
        <Box sx={{padding: {md: "40px", xs: "20px"}}} className={`max-w-[1560px] m-auto gap-[10px] text-center ${i18n.language === "en" ? "font-palab" : "font-helvetica-arabic-bold"}`}>
          <h2 className={`sm:text-5xl max-sm:text-2xl mb-4 text-primaryColor`}>{t("guest_testimonials")}</h2>
          <p className="max-w-[600px] mb-10 m-auto">{t("testimonial_description")}</p>
          <div className="max-w-[700px] m-auto">
          {homeTestimonialLoading 
          ? 
          <div className='flex justify-center w-full'>
            <CircularProgress/>
          </div>
          :
          homeTestimonialError
          ?
          <div className='cursor-pointer flex justify-center w-full'>
            <ReplayIcon onClick={homeTestimonialApi} className='!text-[40px]' />
          </div>
          :
          <>
          <Swiper
            spaceBetween={30}
            navigation
            pagination={{ clickable: true }}
            modules={[Navigation, Pagination]}
            className={`homeSwiper ${styles.homeSwiper}`}
          >
            {testimonialsSection?.map((element, index) => (
              <SwiperSlide 
              className={`
                ${i18n.language === "en" ? "font-palabi": "!font-helvetica-arabic-light"}
              !flex 
              justify-center 
              items-center 
              border-[3px] 
              border-solid 
              border-secondaryColor
              rounded-[20px] 
              bg-gradient-to-tl 
              from-[#F4DDB6]
              to-[#FFFFFF]`} key={index}>
                <TestimonialCard element={element} />
              </SwiperSlide>
            ))}
          </Swiper>
          </>
        }
          </div>
        </Box>
      </div>
      <div  dir={i18n.language === "en" ? "ltr" : "rtl"} className="py-10 bg-primaryColor">
        <ContactSection/>
      </div>
    </div>
  )
}

export default Home
